import apiClient from "./api";

export const getAssetTypes = async () => {
  const response = await apiClient.get("/asset-types");
  return response.data.data || [];
};

export const getPropertyDefinitions = async () => {
  const response = await apiClient.get("/properties");
  return response.data.data || [];
};

export const getAssetType = async (id) => {
  const response = await apiClient.get(`/asset-types/${id}`);
  return response.data;
};

export const createAssetType = async (assetType) => {
  const response = await apiClient.post("/asset-types", assetType);
  return response.data;
};

export const updateAssetType = async (id, assetType) => {
  const response = await apiClient.put(`/asset-types/${id}`, assetType);
  return response.data;
};

export const createPropertyDefinition = async (property) => {
  const response = await apiClient.post("/properties", property);
  return response.data;
};

export const updatePropertyDefinition = async (id, property) => {
  const response = await apiClient.put(`/properties/${id}`, property);
  return response.data;
};

export const bulkCreateAssetTypes = async (formData) => {
  const response = await apiClient.post("/asset-types/bulk-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deletePropertyDefinition = async (id) => {
  const response = await apiClient.delete(`/properties/${id}`);
  return response.data;
};
